var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8BahrainCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#eceff1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c62828",
    d: "M13,12l10,4l-10,4l10,4l-10,4l10,4l-10,4l10,4l-6.418,2.567C18.875,43.488,21.376,44,24,44 c11.046,0,20-8.954,20-20c0-11.046-8.954-20-20-20c-2.624,0-5.125,0.512-7.418,1.433L23.001,8L13,12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8BahrainCircular);
export default __webpack_public_path__ + "static/media/icons8-bahrain-circular.e83f840e3dc70d8f9db64c3a915e6acc.svg";
export { ForwardRef as ReactComponent };